<div class="overlay" *ngIf="showOverlay" role="status" aria-live="polite" (click)="toggleAssistant()">
  <div class="message-box">
    <p>{{ assistantMessage || 'Elaborazione in corso...' }}</p>
  </div>
</div>

<div *ngIf="!showOverlay" class="assistant-container" [class.open]="isOpen" tabindex="0" role="region"
     aria-label="Assistente vocale Glammy" (keydown.escape)="toggleAssistant()">
  <button class="toggle-btn" type="button" (click)="toggleAssistant()" [attr.aria-pressed]="isOpen"
          [attr.aria-label]="isOpen ? 'Chiudi assistente' : 'Apri assistente'">
    <ion-icon [name]="isOpen ? 'close' : 'radio-outline'" aria-hidden="true"></ion-icon>
  </button>

  <div class="chat-box" *ngIf="isOpen" role="dialog" aria-modal="false" [attr.aria-labelledby]="'assistant-title'">
    <div class="chat-header">
      <div class="title-row">
        <span id="assistant-title">Glammy</span>
        <img alt="Beta version" src="assets/questionnaire/icons8-pulsante-beta.svg" />
        <!-- <span class="info-button" title="Guida all'uso">?</span> -->
        <button class="info-button" type="button" (click)="openAssistantInfo()" title="Informazioni"
                aria-label="Informazioni assistente">
          i
        </button>
      </div>
      <div>
        <!-- Checkbox per abilitare/disabilitare il download automatico dell'audio -->
        <!-- <label class="download-checkbox" title="Scarica automaticamente l'audio">
          <input type="checkbox" [checked]="shouldDownload" (change)="toggleShouldDownload($event)" />
          <span class="label-text">Scarica audio</span>
        </label> -->
      </div>
    </div>

    <div class="chat-content">
      <div class="record-container">
        <!-- Icona ingrandita e blu -->
        <ion-icon name="mic-circle-outline" class="assistant-icon large blue" [class.pulse]="isRecording"
                  aria-hidden="true">
        </ion-icon>
        <!-- Listening.... -->
        <div class="listening-indicator" aria-live="polite" aria-atomic="true" role="status">
          <span class="dots">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </span>
          <span class="listening-text">{{vocalMessage}}</span>
        </div>
      </div>
    </div>
  </div>
</div>